import DepositFixedTermSettings from "@/models/Products/ProductSettings/DefaultSettings/FixedTerm/DepositFixedTermSettings";
import CurrencyUtils from "@/lib/currencyUtils";

export default class UpdateDepositFixedTermSettingsRequest extends DepositFixedTermSettings {
    updatedAt: Date;

    public constructor(settings: DepositFixedTermSettings, updatedAt: Date, defaultWalletCurrency: string) {
        super();
        this.updatedAt = updatedAt;
        if (settings) {
            this.overridable = settings.overridable
            this.termPeriodType = settings.termPeriodType;
            this.termPeriodValue = +settings.termPeriodValue;
            this.minimumBalance = settings.minimumBalance;
            this.minimumBalance.amount = CurrencyUtils.convertDecimalStringToAmountString(this.minimumBalance.amount);
            this.minimumBalance.currency = defaultWalletCurrency;
            this.maximumBalance = settings.maximumBalance;
            this.maximumBalance.amount = CurrencyUtils.convertDecimalStringToAmountString(this.maximumBalance.amount);
            this.maximumBalance.currency = defaultWalletCurrency;
            this.initialDepositWindowPeriodType = settings.initialDepositWindowPeriodType;
            this.initialDepositWindowPeriodValue = +settings.initialDepositWindowPeriodValue;
            this.fundingWindowPeriodType = settings.fundingWindowPeriodType;
            this.fundingWindowPeriodValue = +settings.fundingWindowPeriodValue;
        }
    }
}